import {
  addAdditionalContactCard,
  appraiserContactCard,
  attorneyContactCard,
  counterpartyTCCard,
  homeWarrantyContactCard,
  leadSourceCard,
  lenderContactCard,
  notesCard,
  otherContactCard,
  propertyDetailsCard,
} from '../shared';
import type { DefaultCoverSheetConfig, LocaleOverrides } from '../types';
import {
  buyerCard,
  buyersAgentCard,
  clientGroupCard,
  commissionDetailsCard,
  emdCard,
  importantDatesCard,
  propertyBeingSoldCard,
  salesPriceCard,
  sellerCard,
  sellersAgentCard,
  titleOfficerContactCard,
} from './cards';

export const BaseOfferConfig = {
  version: '1',
  sections: {
    propertyInfo: {
      id: 'propertyInfo',
      header: 'Property Info',
      sidebarText: 'Property Info',
      cards: {
        propertyBeingSoldCard,
        importantDatesCard,
        salesPriceCard,
        commissionDetailsCard,
        emdCard,
        propertyDetailsCard,
        notesCard,
      },
    },
    buySideContacts: {
      id: 'buySideContacts',
      header: "Buyer's Contacts",
      sidebarText: 'Buyer Contacts',
      cards: {
        buyersAgentCard,
        buyerCard,
        clientGroupCard,
        leadSourceCard: {
          ...leadSourceCard,
          id: 'buyerSideContacts.leadSource',
        },
      },
    },
    sellerSideContacts: {
      id: 'sellerSideContacts',
      header: "Seller's Contacts",
      sidebarText: 'Seller Contacts',
      cards: {
        sellersAgentCard,
        sellerTCCard: {
          ...counterpartyTCCard,
          id: 'sellerSideContacts.sellerTC',
          innerTitle: "Seller's Transaction Coordinator",
          outerTitle: "Seller's Transaction Coordinators",
          addableTitle: "Seller's Transaction Coordinator",
        },
        sellerCard,
      },
    },
    additionalContacts: {
      id: 'additionalContacts',
      header: 'Additional Contacts',
      sidebarText: 'Additional Contacts',
      cards: {
        titleOfficerContactCard,
        lenderContactCard,
        appraiserContactCard,
        attorneyContactCard,
        homeWarrantyContactCard,
        otherContactCard,
        addAdditionalContactCard,
      },
    },
  },
} satisfies DefaultCoverSheetConfig;

export type OfferLocaleOverrides = LocaleOverrides<typeof BaseOfferConfig>;
